import type { Sizing } from "@/composables/forms/formTypes";
import type { FormStoreState } from "@/plugins/piniaForm";
import { defineStore } from "pinia";

type SizingState = FormStoreState<Sizing>;

export const useSizingStore = defineStore({
  id: "sizing",
  state: (): SizingState => ({
    formData: {} as Sizing,
    initialData: {} as Sizing,
    requiredFields: ["title", "disposition", "default_display_units"]
  }),
  getters: {},
  actions: {},
  useForm: true
});
